// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails___Oa_-","detailsBorder":"styles_detailsBorder__3MuvX"};